import { render, staticRenderFns } from "./FulfillmentInfo.vue?vue&type=template&id=688f123c&"
import script from "./FulfillmentInfo.vue?vue&type=script&lang=js&"
export * from "./FulfillmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports